export enum ReviewType {
    google = 'google',
    nps = 'nps',
}
